import request from '@/services/request'
import { tryParseJson } from './utils'
import router from '../routers'

/**
 * 登录内容信息
 * */
export function loginContent(params) {
  return request({
    url: '/student/map',
    method: 'get',
    params
  })
}

/**
 * 登录
 * */
export function login(data) {
  return request({
    url: '/student/login',
    method: 'post',
    data
  })
}

/**
 * 试题上传
 * */
export function answerUpload(data) {
  return request({
    // url: '/util/doUpload',
    url: '/student/submit',
    method: 'post',
    data: Object.assign(data, { 'subject_group': sessionStorage.urlId, 'batch': sessionStorage.batch })
  })
}

export function getChartData(params) {
  return request({
    url: '/seir_simulator',
    method: 'get',
    params
  })
}

/* 剩余时间上传 */
export function submitTime(data) {
  return request({
    url: '/student/submitTime',
    method: 'post',
    data
  })
}

const statsKind = {
  /** 批判任务、批判任务+问卷 */
  criticismTask: 1,
  /** 创新问卷、创新学生问卷 */
  innovationSurvey: 10,
  /** 创新任务、创新任务+问卷 */
  innovationTask: 11,
  /** 教师问卷、创新老师问卷 */
  teacherSurvey: 20,
  /** 过程数据 */
  processData: 90
}

const isEmpty = value => value == null || String(value).trim() === ''

/**
 * 将查询数据转成后端需要的 kind 数据。
 *
 * @param {{
 *    subject: string
 *    time?: string
 *    type?: string
 * }} query 查询数据
 * @returns number
 */
function queryToKind(query) {
  // type 为 public 的，为练习题，不参与统计
  if (query.type == 'public') {
    return 0
  }
  // /exam/login?subject=phone 批判练习，不参与统计，该链接也不会出现了
  if (query.subject == 'phone' && isEmpty(query.time)) {
    return 0
  }
  // /exam/login?subject=phone&time=pm 批判年级组卷--分中（2套BC）、小学（2套DE）
  if (query.subject == 'phone') {
    return statsKind.criticismTask
  }
  // /exam/login?subject=controller 创新练习 + 学生问卷---创新问卷
  if (query.subject == 'controller' && isEmpty(query.time)) {
    return statsKind.innovationSurvey
  }
  // /exam/login?subject=controller&time=pm 创新年级组卷--分中（ABC）、小学(CDE)---创新任务
  if (query.subject == 'controller' && query.time) {
    return statsKind.innovationTask
  }
  // /exam/login?subject=teacher
  if (query.subject == 'teacher') {
    return statsKind.teacherSurvey
  }
  return 0
}

const KEY_STATS_COMMON = 'STATS_COMMON'

const postData = (url, data) => request({ url, method: 'post', headers: { 'Content-Type': 'application/json' }, data })

/**
 * 登陆统计。
 *
 * @param {{
 *    province_id: number
 *    city_id: number
 *    county_id: number
 *    school_id: number
 *    grade_id: number
 *    class_id: number
 *    stu_num: string
 *    stu_name: string
 * }} data 统计数据
 * @param {{
 *    subject: string
 *    time?: string
 *    type?: string
 * }} query 查询数据
 */
export function statsLogin(data, query) {
  const kind = queryToKind(query)
  if (kind > 0) {
    // 保存起来 statsResult 使用
    const common = { kind, ...data }
    sessionStorage.setItem(KEY_STATS_COMMON, JSON.stringify(common))
    return postData('/stats/login', common)
  }
}

export function statsProcess(data) {
  const common = tryParseJson(sessionStorage.getItem(KEY_STATS_COMMON), {})
  common.kind = statsKind.processData
  // 将创新、匹配标志计入 process data 中
  const meta = router.currentRoute.meta || {}
  if (meta.innovation) {
    data.innovation = true
  }
  if (meta.criticism) {
    data.criticism = true
  }
  common.data = JSON.stringify(data || {})
  return postData('/stats/process', common)
}

export function statsResult(data) {
  const common = tryParseJson(sessionStorage.getItem(KEY_STATS_COMMON), {})
  common.data = JSON.stringify(data || {})
  return postData('/stats/result', common)
}

/**
 * 检查是否可以进入考试
 * param {
 *  subject_group: string // 科目组id，不传检验全部考试题
 * }
 */
export function checkStatus(params) {
  return request({
    url: '/student/checkStatus',
    method: 'get',
    params
  })
}
